import { loginCustomer, passwordRecovery } from "@/api/modules/login";
import { calculateRefund, requestRefund } from "@/api/modules/fullvoucherrefund"

function initialState() {
    return {
        phoneNumber: null,
        phoneCountryCode: "45",
        password: null,
        loginActionType: LOGIN_ACTION_TYPE_LOGIN,
        isDanishCustomer: true,
        cprNumber: null,
        registrationNumber: null,
        accountNumber: null,
        swiftCode: null,
        ibanCode: null,
        isRefundViaRegistrationNumber: true
    };
}

function getPhoneNumberError(_state, getters, _rootState, rootGetters) {
    var value = _state.phoneNumber;
    if (!value || value === '') {
        return ERROR_REQUIRED;
    }

    const number = Number(value);
    if (!Number.isInteger(number)){
        return ERROR_NOT_VALID_PHONE_NUMBER;
    }

    return null;
}

function getPhoneCountryCodeError(_state, getters, _rootState, rootGetters) {
    var value = _state.phoneCountryCode;
    if (!value || value === '') {
        return ERROR_REQUIRED;
    }

    const number = Number(value);
    if (!Number.isInteger(number)){
        return ERROR_NOT_VALID_PHONE_COUNTRY_CODE;
    }

    return null;
}

function getPasswordError(_state, getters, _rootState, rootGetters) {
    var value = _state.password;
    if (!value || value === '') {
        return ERROR_REQUIRED;
    }

    return null;
}

function getCprNumberError(_state, getters, _rootState, rootGetters) {
    var value = _state.cprNumber;
    if (!value || value === '') {
        return ERROR_REQUIRED;
    }

    return null;
}

function getRegistrationNumberError(_state, getters, _rootState, rootGetters) {
    var value = _state.registrationNumber;
    if (!value || value === '') {
        return ERROR_REQUIRED;
    }

    return null;
}

function getAccountNumberError(_state, getters, _rootState, rootGetters) {
    var value = _state.accountNumber;
    if (!value || value === '') {
        return ERROR_REQUIRED;
    }

    return null;
}

function getSwiftCodeError(_state, getters, _rootState, rootGetters) {
    var value = _state.swiftCode;
    if (!value || value === '') {
        return ERROR_REQUIRED;
    }

    return null;
}

function getIbanCodeError(_state, getters, _rootState, rootGetters) {
    var value = _state.ibanCode;
    if (!value || value === '') {
        return ERROR_REQUIRED;
    }

    return null;
}

export const ERROR_REQUIRED = "error_required";
export const ERROR_NOT_VALID_PHONE_NUMBER = "error_not_valid_phone_number";
export const ERROR_NOT_VALID_PHONE_COUNTRY_CODE = "error_not_valid_phone_country_code";
export const LOGIN_ACTION_TYPE_LOGIN = "login_action_type_login";
export const LOGIN_ACTION_TYPE_FORGOT_PASSWORD = "login_action_type_forgot_password";

export const state = initialState();

export const getters = {
    getPhoneNumber: state => state.phoneNumber,
    getPhoneNumberError,
    getPhoneCountryCode: state => state.phoneCountryCode,
    getPhoneCountryCodeError,
    getPassword: state => state.password,
    getPasswordError,
    isLoginAction: state => state.loginActionType === LOGIN_ACTION_TYPE_LOGIN,
    isDanishCustomer: state => state.isDanishCustomer,
    getCprNumber: state => state.cprNumber,
    getCprNumberError: getCprNumberError,
    getRegistrationNumber: state => state.registrationNumber,
    getRegistrationNumberError: getRegistrationNumberError,
    getAccountNumber: state => state.accountNumber,
    getAccountNumberError: getAccountNumberError,
    getSwiftCode: state => state.swiftCode,
    getSwiftCodeError: getSwiftCodeError,
    getIbanCode: state => state.ibanCode,
    getIbanCodeError: getIbanCodeError,
    isRefundViaRegistrationNumber: state => state.isRefundViaRegistrationNumber
};

export const mutations = {
    setPhoneNumber: (state, number) => {
        state.phoneNumber = number;
    },
    setPhoneCountryCode: (state, code) => {
        state.phoneCountryCode = code;
    },
    setPassword: (state, password) => {
        state.password = password;
    },
    setLoginActionType: (state, type) => {
        state.loginActionType = type;
    },
    setCustomerNationality: (state, isDanishCustomer) => {
        state.isDanishCustomer = isDanishCustomer;
    },
    setCprNumber: (state, cprNumber) => {
        state.cprNumber = cprNumber;
    },
    setRegistrationNumber: (state, registrationNumber) => {
        state.registrationNumber = registrationNumber;
    },
    setAccountNumber: (state, accountNumber) => {
        state.accountNumber = accountNumber;
    },
    setSwiftCode: (state, swiftCode) => {
        state.swiftCode = swiftCode;
    },
    setIbanCode: (state, ibanCode) => {
        state.ibanCode = ibanCode;
    },
    setRefundMethod: (state, isRefundViaRegistrationNumber) => {
        state.isRefundViaRegistrationNumber = isRefundViaRegistrationNumber;
    }
};

export const actions = {
    login: (context, { phoneCountryCode, phoneNumber, password }) => {
        return loginCustomer(phoneCountryCode,
            phoneNumber,
            password)
            .then(response => {
                if (!response.ok) return Promise.reject(response);
                return Promise.resolve(response.responseBody.token);
            });
    },
    passwordReset: (context, { phoneCountryCode, phoneNumber }) => {
        return passwordRecovery(phoneCountryCode,
            phoneNumber)
            .then(response => {
                if (!response.ok) return Promise.reject(response);
                return Promise.resolve();
            });
    },
    calculate: (context, { accessToken }) => {
        return calculateRefund(accessToken)
        .then(response => {
            if (!response.ok) return Promise.reject(response);
            return Promise.resolve(response.responseBody);
        });
    },
    resetState: (context) => {
        context.commit("setPassword", null);
        context.commit("setPhoneNumber", null);
    },
    request: (context,
        {
            name,
            address,
            postalCode,
            city,
            country,
            cpr,
            dkRegistrationNumber,
            dkAccountNumber,
            swiftNumber,
            ibanNumber,
            accessToken
        }) => {
            return requestRefund(name,
                address,
                postalCode,
                city,
                country,
                cpr,
                dkRegistrationNumber,
                dkAccountNumber,
                swiftNumber,
                ibanNumber,
                accessToken)
            .then(response => {
                if (!response.ok) return Promise.reject(response);
                return Promise.resolve(response.responseBody);
            });
    }
};
